import React from 'react'
import SkipLink from '../../skiplink/SkipLink'

export const AppLayout = ({ children }) => {
  return (
    <>
      <SkipLink skipTo="article h1:first-of-type" className="primary skip-link">
        <button type="button">Skip to content</button>
      </SkipLink>
      <div className="fairwork-wrapper">{children}</div>
    </>
  )
}
